import { FormControl, MenuItem, Select, Typography } from '@mui/material';

export default function CommonSelect(props) {
  const { selectHead, selectList, name, labelinput, style, value, className, onChange, disabled, variant, placeholder } = props;
  return (
    <FormControl variant={variant} sx={{ width: '100%' }}>
      {labelinput && <Typography fontSize={{ xs: '12px', sm: '13px' }} fontWeight={500} mb={'2px'}>{labelinput}</Typography>}
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        fullWidth
        sx={style}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
      >
        {selectHead && <MenuItem value="" hidden>{selectHead}</MenuItem>}
        {selectList?.map((data, i) => {
          return (
            <MenuItem value={name === 'pincode' ? data?.pincode : data?.id} key={i}>{data?.serviceName || data?.name || data?.subServiceName || data?.state || data?.city || data?.slotTime || data?.pincode}</MenuItem>
          )
        })}
      </Select>
    </FormControl>
  );
}